export const compareStringsIgnoreCase = (str1: string, str2: string) => {
  // Remove non-alphanumeric characters from the strings
  const cleanStr1 = str1.replace(/[^a-zA-Z0-9]/g, "");
  const cleanStr2 = str2.replace(/[^a-zA-Z0-9]/g, "");

  // Convert the cleaned strings to lowercase and compare
  return cleanStr1.toLowerCase() === cleanStr2.toLowerCase();
};
